import React from "react";
import { Spin } from "antd";
import { useStore } from "@/src/store/store";

const Loading = () => {
  const { loading } = useStore();
  return <Spin spinning={loading} fullscreen size="large" />;
};

export default Loading;
